import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "preSaleCommPlan" }
const _hoisted_2 = { class: "tableHeader" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"margin-left":"8px"} }
const _hoisted_5 = { class: "handler" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_7 = {
  key: 1,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_8 = { class: "popup" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]

import { searchFormConfig } from './config/search.config'
import { computed, onMounted, reactive, ref, UnwrapRef, watch } from 'vue'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import {
  deletePageData,
  downloadData,
  editPageData,
  getListData,
  getPageListData
} from '@/service/main/system'
import type {
  ContextmenuPopupArg,
  STablePaginationConfig
} from '@surely-vue/table'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import { useStore } from '@/store'
import { message } from 'ant-design-vue'
import localCache from '@/utils/cache'
import { ElMessage, ElMessageBox } from 'element-plus'
import { initEmptyParam } from '@/hooks/useInitParam'
import { Excel } from '@/utils/ExcelJs'
import { usePermission } from '@/hooks/usePermission'
import {useUploadSimple} from "@/hooks/useUploadSimple";

interface DataItem {
  key: string
  developerName: string
  avatarName: string
  resourceTime: string
  resourceChannel: string
  customerName: string
  customerNickName: string
  compositeField: string
  billingAmount: string
  customerFunds: string
  fundsProofImgUrls: string
  favoriteTeacher: string
  teacherProofImgUrls: string
  sex: string
  signingExperience: string
  totalAssets: string
  holdShares: string
  ownFunds: string
  stockAge: string
  recentOprTime: string
  isSigned: string
  spendPackage: string
  customerDemand: string
  customerLivingCondition: string
  hasGuideCustomer: string
  hasInteract: string
  isExplainClearlyHasEvidence: string
  isOneMinCall: string
  teachingStaff: string
  billingTime: string
  drainageTime: string
  createTime: string
  createdBy: string
  id: string
  updateTime: string
  updatedBy: string
}

const editUrl = '/main/coordinationMechanism/save'

export default /*#__PURE__*/_defineComponent({
  __name: 'CoordinationMechanism',
  setup(__props) {

initEmptyParam()

const store = useStore()
const userInfo = store.state.login.userInfo
console.log(userInfo)
let queryParam = ref()
if (userInfo.isManager != '1') {
  if(userInfo.empTag == '0') {
    queryParam.value = {
      developerNames: userInfo.realName
    }
  } else {
    queryParam.value = {
      teachingStaffIds: userInfo.id
    }
  }

} else {
  queryParam.value = {
    deptId: userInfo.deptId
  }
}
store.commit('system/changeQueyryInfo', queryParam.value)

dayjs.locale('zh-cn')

let count = 0
const preSalSearchRef = ref()

const corpNames: any = ref([])

const canWrite = usePermission('coordinationMechanism', 'write')
const canRead = usePermission('coordinationMechanism', 'read')
const canCheck = usePermission('coordinationMechanism', 'check')

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpName'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.name }
  })

  corpNames.value = roleData.map((item: any) => {
    return { label: item.name, value: item.name }
  })
}

getCompanyList()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id + '' }
  })

  const userOptionsDevelop = userList.map((item: any) => {
    return { title: item.realName, value: item.realName }
  })

  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'developerNames'
  )
  userItem!.options = userOptionsDevelop

  const userItem2 = searchFormConfig.formItems.find(
    (item) => item.field === 'teachingStaffIds'
  )
  userItem2!.options = userOptions
}
getEmp()

const getFavoriteTeacher = async () => {
  let teacherList = await getListData(
    '/main/dictItem/queryByDictId/1846093791170269184',
    {}
  )
  localCache.setCache('teacherData', teacherList)
  const teacher = searchFormConfig.formItems.find(
    (item) => item.field === 'favoriteTeacher'
  )
  teacher!.options = teacherList.map((item: any) => {
    return { title: item.itemText, value: item.itemValue }
  })
}
getFavoriteTeacher()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'deptId'
  )
  dept!.isDisabled = store.state.login.userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

const pagination = ref<STablePaginationConfig>({
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total) => `共 ${totalSize.value} 条`,
  pageSize: 10,
  current: 1
})

const onDelete = (id: string, key: string, args?: any) => {
  if ('' == id) {
    dataSource.value = dataSource.value.filter((item) => item.key !== key)
  } else {
    deletePageData('/main/coordinationMechanism/' + id).then(() => {
      initTable(pagination.value, queryParam.value)
    })
  }
  args?.hidePopup()
}

const handleVerifyResult = (item?: any) => {
  ElMessageBox.confirm('', {
    title: '核实',
    confirmButtonText: '属实',
    cancelButtonText: '不属实',
    distinguishCancelAndClose: true
  })
    .then((action) => {
      if ('confirm' == action) {
        item.verifyResult = '属实'
        let pageUrl = `/main/coordinationMechanism/verify/${item.id}/${item.verifyResult}`
        editPageData(pageUrl, {}).then(() => {
          initTable(pagination.value, queryParam.value)
        })
      }
    })
    .catch((err) => {
      if ('cancel' == err) {
        item.verifyResult = '不属实'
      }
      let pageUrl = `/main/coordinationMechanism/verify/${item.id}/${item.verifyResult}`
      editPageData(pageUrl, {}).then(() => {
        initTable(pagination.value, queryParam.value)
      })
    })
}

const handleAdd = (args?: any) => {
  const newData = {
    key: `${count}`,
    developerName: '',
    avatarName: '',
    resourceTime: '',
    resourceChannel: '',
    customerName: '',
    customerNickName: '',
    compositeField: '',
    billingAmount: '',
    customerFunds: '',
    fundsProofImgUrls: '',
    favoriteTeacher: '',
    teacherProofImgUrls: '',
    sex: '',
    signingExperience: '',
    totalAssets: '',
    holdShares: '',
    ownFunds: '',
    stockAge: '',
    recentOprTime: '',
    isSigned: '',
    spendPackage: '',
    customerDemand: '',
    customerLivingCondition: '',
    hasGuideCustomer: '',
    hasInteract: '',
    isExplainClearlyHasEvidence: '',
    isOneMinCall: '',
    teachingStaff: '',
    billingTime: '',
    drainageTime: '',
    createTime: '',
    createdBy: '',
    id: '',
    updateTime: '',
    updatedBy: ''
  }
  count++
  dataSource.value.unshift(newData)
  dataSource.value = [].concat(dataSource.value)
  args?.hidePopup()
}

const selectCols = ref([])

let totalSize = ref(0)

const handleSearchClick = (formdata: any) => {
  console.log(formdata)
  queryParam.value = formdata
  pagination.value.current = 1 //init page
  initTable(pagination.value, formdata)
}
const handleResetClick = () => {
  initTable(pagination.value, queryParam.value)
}

const dataSource = ref<DataItem[]>([])
const importAction =
  process.env.VUE_APP_BASE_URL + '/main/coordinationMechanism/dataImport'
const importActionTry =
  process.env.VUE_APP_BASE_URL + '/main/coordinationMechanism/dataImportTry'

const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`
}
const handleImportSuccess = (res: any) => {
  if (res.length > 0) {
    const errs = res
      .map((item: any) => {
        if (item.reason.indexOf('规范') == -1) {
          return item.reason
        } else {
          return (
            '<span style="color:darkorange !important;">' + item.reason + '</span>'
          )
        }
      })
      .join(',<br/>')
    if (res.length > 1) {
      ElMessage({
        dangerouslyUseHTMLString: true,
        type: 'error',
        message: '导入存在异常数据如下：<br/>' + errs
      })
    } else {
      ElMessage({
        type: 'success',
        message: '导入成功：' + errs
      })
    }
  } else {
    initTable(pagination.value, queryParam.value)
    if (res.code == 200) {
      ElMessage({
        type: 'success',
        message: '导入成功'
      })
    } else {
      ElMessage({
        type: 'error',
        message: '导入失败，文件异常，请检查是否有持股贴图'
      })
    }
  }
}

const state = reactive<{
  selectedRowKeys: []
  loading: boolean
}>({
  selectedRowKeys: [], // Check here to configure the default column
  loading: false
})
const hasSelected = computed(() => state.selectedRowKeys.length > 0)
const selectedRowKeys = computed(() => state.selectedRowKeys)
const start = () => {
  state.loading = true
  // ajax request after empty completing
  setTimeout(() => {
    state.loading = false
    state.selectedRowKeys = []
  }, 1000)
}
const onSelectChange = (selectedRowKeys: []) => {
  console.log('selectedRowKeys changed: ', selectedRowKeys)
  state.selectedRowKeys = selectedRowKeys
}

const handleBatchDelete = () => {
  var pageNum = pagination.value.current || 1
  var pageSize = pagination.value.pageSize || 10
  ElMessageBox.confirm('确定要删除选中的数据吗', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    var ids = selectedRowKeys.value
      .map((o) => dataSource.value[(pageNum - 1) * pageSize + parseInt(o)].id)
      .join(',')
    deletePageData('/main/coordinationMechanism/batch/' + ids).then(() => {
      initTable(pagination.value, queryParam.value)
      state.selectedRowKeys = []
      state.loading = false
    })
  })
}

const customHeaderCell = (column: any) => {
  const redArray = [
    'signingExperience',
    'totalAssets',
    'holdShares',
    'ownFunds',
    'stockAge',
    'recentOprTime',
    'spendPackage',
    'customerLivingCondition',
    'hasGuideCustomer',
    'hasInteract',
    'isExplainClearlyHasEvidence'
  ]
  const backArray = [
    'developerName',
    'avatarName',
    'resourceTime',
    'resourceChannel',
    'customerName',
    'customerNickName',
    'compositeField',
    'billingAmount',
    'customerFunds',
    'fundsProofImgUrls',
    'favoriteTeacher',
    'isSigned',
    'teacherProofImgUrls',
    'sex',
    'createTime',
    'updateTime',
    'empName',
    'deptName',
    'customerDemand',
    'isOneMinCall',
    'operation',
    'billingTime',
    'drainageTime',
    'teachingStaff',
    'verifyResult'
  ]
  if (redArray.indexOf(column.dataIndex) != -1) {
    return { style: { color: '#ff0000' } }
  }
  if (backArray.indexOf(column.dataIndex) != -1) {
    return {
      style: { fontWeight: 'bold' }
    }
  }
  if (column.title == '九大资讯') {
    return {
      style: { fontWeight: 'bold', backgroundColor: 'rgb(251,228,213)' }
    }
  }
  return {}
}

const handleImportError = (res: any) => {
  console.log(res)
}

const handleDownloadImport = () => {
  const fileName = '小单协助机制.xlsx'
  downloadData(
    '/main/coordinationMechanism/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleExport = () => {
  getPageListData(
    '/main/coordinationMechanism/download',
    {
      ...queryParam.value,
      pageNo: pagination.value.current,
      pageSize: pagination.value.pageSize
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    }) //处理文档流
    const down = document.createElement('a')
    down.download =
      '小单协作机制' +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const previewUpdateDialog = ref(false)
const userList = ref([])
const previewUpdate = () => {
  getUserList()
  previewUpdateDialog.value = true
}

const getUserList = () => {
  getListData('/main/coordinationMechanism/getUserList', {}).then((res) => {
    userList.value = res
  })
}

const initTable = (params: STablePaginationConfig = {}, query?: any) => {
  getPageListData('/main/coordinationMechanism/queryByCondition', {
    ...query,
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize
  }).then((res) => {
    dataSource.value = res.list
    totalSize.value = res.total
    count = dataSource.value.length
    pagination.value = {
      ...params,
      total: totalSize.value
    }
  })
}
onMounted(() => {
  initTable(pagination.value, queryParam.value)
})

watch(
  () => ({ ...pagination.value }),
  (cur, pre) => {
    if (cur.current !== pre.current || cur.pageSize !== pre.pageSize) {
      initTable(pagination.value, queryParam.value)
    }
  }
)

function getValueSetter() {
  return ({ record, column, row, newValue, oldValue }: any) => {
    let stack = new Error().stack
    if (stack.indexOf('handleKeyDown') != -1) {
      return true
    }
    let field = column.dataIndex
    let body = {}
    body[field] = newValue
    body['id'] = record.id
    editPageData(editUrl, body).then(() => {
      initTable(pagination.value, queryParam.value)
    })
    return true
  }
}

const columns = [
  {
    title: '开发人名字',
    dataIndex: 'developerName',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 110,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '使用开发头像的名字',
    dataIndex: 'avatarName',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 110,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '资源时间',
    dataIndex: 'resourceTime',
    type: 'date',
    width: 180,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '资源渠道（诊股/信息流）',
    dataIndex: 'resourceChannel',
    type: 'resourceChannel',
    width: 150,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '客户姓名',
    dataIndex: 'customerName',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 90,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '客户昵称',
    dataIndex: 'customerNickName',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 90,
    align: 'center',
    resizable: true,
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '小单企微ID+小单企微主体+客户编码ID',
    dataIndex: 'compositeField',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 160,
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '开单金额',
    dataIndex: 'billingAmount',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 150,
    resizable: true,
    align: 'center',
    fixed: 'left',
    valueSetter: getValueSetter()
  },
  {
    title: '九大资讯',
    align: 'center',
    children: [
      {
        title: '客户资金量',
        dataIndex: 'customerFunds',
        type: 'textarea',
        width: 180,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '资金量证明图',
        dataIndex: 'fundsProofImgUrls',
        type: 'image',
        width: 180,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '客户认可哪位老师（闫峰/郑礼/程超/孙腾）',
        dataIndex: 'favoriteTeacher',
        type: 'textarea',
        width: 160,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      },
      {
        title: '认可老师证明图',
        dataIndex: 'teacherProofImgUrls',
        type: 'image',
        width: 180,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '性别',
        dataIndex: 'sex',
        type: 'sex',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '签约经历：（未了解到小单单量提成打5折）',
        dataIndex: 'signingExperience',
        type: 'textarea',
        autoHeight: true,
        editable: 'cellEditorSlot',
        width: 320,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter()
      },
      {
        title: '账户总资产：（未了解到小单单量提成打5折）',
        dataIndex: 'totalAssets',
        type: 'textarea',
        autoHeight: true,
        editable: 'cellEditorSlot',
        width: 200,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter()
      },
      {
        title: '持股：（未了解到小单单量提成打5折）',
        dataIndex: 'holdShares',
        type: 'textarea',
        autoHeight: true,
        width: 300,
        align: 'center',
        resizable: true,
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '是否自有资金（未了解到小单单量提成打5折）',
        dataIndex: 'ownFunds',
        type: 'select',
        width: 100,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title: '股龄（未了解到小单单量提成打5折）',
        dataIndex: 'stockAge',
        width: 100,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '近期操作股票的时间：（未了解到小单单量提成打5折）',
        dataIndex: 'recentOprTime',
        width: 200,
        type: 'input',
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: true
      },
      {
        title: '是否签合同',
        dataIndex: 'isSigned',
        type: 'select',
        width: 120,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        editable: 'cellEditorSlot'
      },
      {
        title:
          '缴费金额+服务期时长（交钱金额三位数以下没有签合同的没有小单单量提成）',
        dataIndex: 'spendPackage',
        type: 'textarea',
        width: 160,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      },
      {
        title: '客户生活情况：（了解到必须如实填写否则小单业绩充公）',
        dataIndex: 'customerLivingCondition',
        type: 'textarea',
        width: 400,
        resizable: true,
        align: 'center',
        valueSetter: getValueSetter(),
        autoHeight: true,
        editable: 'cellEditorSlot'
      }
    ]
  },
  {
    title: '客户交钱后的需求',
    dataIndex: 'customerDemand',
    type: 'textarea',
    width: 260,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title:
      '是否引流前在单聊/电话过程中有至少1次引导客户听课的动作（未执行罚款小单人员100元/次，管理人员承担相应的连带责任，如果部门检查出来自罚的不用连带）',
    dataIndex: 'hasGuideCustomer',
    type: 'select',
    width: 200,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title:
      '小单在引流投教之前是否有互动记录（无互动记录小单单量和小单升级业绩充公）（如果签合同，只有升级提成，没有小单单量提成',
    dataIndex: 'hasInteract',
    type: 'select',
    width: 200,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '是否两种服务（锦囊妙计+以教带练）按照公司的产品给客户讲清楚并且微信上有留痕，否则罚款100元/次。',
    dataIndex: 'isExplainClearlyHasEvidence',
    type: 'select',
    width: 200,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '客户成交之前是否有1分钟以上电话（是/否）',
    dataIndex: 'isOneMinCall',
    type: 'select',
    width: 200,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '投教人员',
    dataIndex: 'teachingStaff',
    type: 'textarea',
    autoHeight: true,
    editable: 'cellEditorSlot',
    width: 120,
    align: 'center',
    resizable: true,
    valueSetter: getValueSetter()
  },
  {
    title: '小单开单时间',
    dataIndex: 'billingTime',
    type: 'date',
    width: 150,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '引流时间',
    dataIndex: 'drainageTime',
    type: 'date',
    width: 150,
    resizable: true,
    align: 'center',
    valueSetter: getValueSetter(),
    editable: 'cellEditorSlot'
  },
  {
    title: '填报人',
    dataIndex: 'empName',
    type: 'input',
    width: 100,
    align: 'center',
    resizable: true,
    autoHeight: true
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    type: 'input',
    width: 100,
    align: 'center',
    resizable: true,
    autoHeight: true
  },
  {
    title: '核实结果',
    dataIndex: 'verifyResult',
    type: 'input',
    width: 100,
    align: 'center',
    fixed: 'right'
  },
  {
    title: '操作',
    width: 200,
    resizable: true,
    key: 'operation',
    align: 'center',
    dataIndex: 'operation',
    fixed: 'right'
  }
]
const currentRecord: any = ref({})
const currentColumnIndex = ref('')
const setCurrentRecord = (record: any, columnIndex: any) => {
  currentRecord.value = record
  currentColumnIndex.value = columnIndex
}

const showViewer = ref(false)
const previewSrcList = ref()
const handlePreview = (record: any, columnIndex: string) => {
  console.log(record)
  console.log(columnIndex)
  showViewer.value = true
  previewSrcList.value = record[columnIndex].split(',')
}
const closeViewer = () => {
  showViewer.value = false
}

const onSuccessUpload = () => {
  filesMap.value.forEach((value: string, key: string) => {
    currentRecord.value[currentColumnIndex.value] = value
  })
  editPageData(editUrl, currentRecord.value).then(() => {
    initTable(pagination.value, queryParam.value)
  })
}

const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  onSuccess,
  onExceed,
  filesMap
] = useUploadSimple()

const handleImgRemove = (uploadFile: any, uploadFiles: any) => {
  filesMap.value.delete(String(uploadFile.uid))
}

const editableData: UnwrapRef<Record<string, DataItem>> = reactive({})

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_copy_outlined = _resolveComponent("copy-outlined")!
  const _component_s_table = _resolveComponent("s-table")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        ref: preSalSearchRef.value,
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: handleResetClick,
        onSearchBtnClick: handleSearchClick
      }, null, 8, ["searchFormConfig"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "default",
            size: "medium",
            loading: state.loading,
            onClick: start
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消全选")
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("span", _hoisted_4, [
            (hasSelected.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(`已选中 ${selectedRowKeys.value.length} 行`), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(canWrite))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "medium",
                onClick: handleAdd
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canWrite))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                size: "medium",
                onClick: handleBatchDelete
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量删除")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canWrite))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                type: "primary",
                size: "medium",
                onClick: handleDownloadImport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("模板下载")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canWrite))
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 3,
                style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
                action: importAction,
                headers: headers.value,
                accept: ".xls,.xlsx",
                "on-success": handleImportSuccess,
                "on-error": handleImportError,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "medium",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("数据导入")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["headers"]))
            : _createCommentVNode("", true),
          (_unref(canWrite))
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 4,
                style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
                action: importActionTry,
                headers: headers.value,
                accept: ".xls,.xlsx",
                "on-success": handleImportSuccess,
                "on-error": handleImportError,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "medium",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("试导入")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["headers"]))
            : _createCommentVNode("", true),
          (_unref(canRead))
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                type: "primary",
                size: "medium",
                onClick: handleExport
              }, {
                default: _withCtx(() => [
                  _createTextVNode("数据导出")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_s_table, {
        bordered: "",
        "data-source": dataSource.value,
        columns: columns,
        stripe: "",
        pagination: pagination.value,
        "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((pagination).value = $event)),
        scroll: { x: 2000 },
        "show-header-scrollbar": "",
        "auto-header-height": "",
        "row-selection": {
        selectedRowKeys: selectedRowKeys.value,
        onChange: onSelectChange
      },
        "custom-header-cell": customHeaderCell
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'operation')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (dataSource.value.length && _unref(canWrite))
                  ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                      key: 0,
                      title: "确定要删除吗?",
                      onConfirm: ($event: any) => (onDelete(record.id, record.key))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"]))
                  : _createCommentVNode("", true),
                (_unref(canCheck))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "warning",
                      size: "small",
                      onClick: ($event: any) => (handleVerifyResult(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("核实")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex === 'fundsProofImgUrls' || column.dataIndex === 'teacherProofImgUrls')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (record.verifyResult == '待审核')
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 0,
                      referrerpolicy: "no-referrer",
                      ref_key: "uploadRef",
                      ref: uploadRef,
                      "auto-upload": true,
                      action: _unref(action),
                      headers: headers.value,
                      data: _unref(extraData),
                      "before-upload": _unref(beforeUpload),
                      "on-success": onSuccessUpload,
                      "on-exceed": _unref(onExceed),
                      accept: ".jpeg,.jpg,.png",
                      "on-remove": handleImgRemove,
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          size: "mini",
                          type: "primary",
                          onClick: ($event: any) => (setCurrentRecord(record, column.dataIndex))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("上传")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["action", "headers", "data", "before-upload", "on-exceed"]))
                  : _createCommentVNode("", true),
                (record[column.dataIndex])
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "mini",
                      type: "primary",
                      onClick: ($event: any) => (handlePreview(record, column.dataIndex))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        cellEditor: _withCtx(({ column, modelValue, save, closeEditor, editorRef }) => [
          (column.type === 'date')
            ? (_openBlock(), _createBlock(_component_a_date_picker, {
                key: 0,
                locale: _unref(locale),
                ref: editorRef,
                bordered: false,
                value: 
              _unref(dayjs)(
                modelValue.value
                  ? modelValue.value
                  : _unref(dayjs)(`${new Date()}`).format('YYYY-MM-DD')
              )
            ,
                style: {"width":"100%"},
                open: "",
                "allow-clear": false,
                "onUpdate:value": 
              (v) => {
                modelValue.value = v?.format('YYYY-MM-DD') ?? ''
                save()
              }
            ,
                onBlur: closeEditor,
                onKeydown: _withKeys(closeEditor, ["esc"]),
                onClick: _withModifiers(closeEditor, ["stop"])
              }, null, 8, ["locale", "value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
            : (column.type === 'select')
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 1,
                  ref: editorRef,
                  bordered: true,
                  value: modelValue.value,
                  style: {"width":"120px"},
                  options: [
              {
                value: '否',
                label: '否'
              },
              {
                value: '是',
                label: '是'
              }
            ],
                  open: "",
                  "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                  onBlur: closeEditor,
                  onKeydown: _withKeys(closeEditor, ["esc"]),
                  onClick: _withModifiers(closeEditor, ["stop"])
                }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
              : (column.type === 'resourceChannel')
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 2,
                    ref: editorRef,
                    bordered: true,
                    value: modelValue.value,
                    style: {"width":"150px"},
                    options: [
              {
                value: '诊股',
                label: '诊股'
              },
              {
                value: '荐股',
                label: '荐股'
              },
              {
                value: '信息流',
                label: '信息流'
              }
            ],
                    open: "",
                    "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                    onBlur: closeEditor,
                    onKeydown: _withKeys(closeEditor, ["esc"]),
                    onClick: _withModifiers(closeEditor, ["stop"])
                  }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                : (column.type === 'sex')
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 3,
                      ref: editorRef,
                      bordered: true,
                      value: modelValue.value,
                      style: {"width":"80px"},
                      options: [
              {
                value: '男',
                label: '男'
              },
              {
                value: '女',
                label: '女'
              }
            ],
                      open: "",
                      "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                      onBlur: closeEditor,
                      onKeydown: _withKeys(closeEditor, ["esc"]),
                      onClick: _withModifiers(closeEditor, ["stop"])
                    }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                  : (column.type == 'textarea')
                    ? (_openBlock(), _createBlock(_component_a_textarea, {
                        key: 4,
                        ref: editorRef,
                        bordered: true,
                        value: modelValue.value,
                        autosize: "true",
                        "onUpdate:value": 
              (v) => {
                modelValue.value = v
              }
            ,
                        onBlur: save,
                        onKeydown: _withKeys(closeEditor, ["esc"])
                      }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                    : _createCommentVNode("", true)
        ]),
        contextmenuPopup: _withCtx((args) => [
          _createElementVNode("ul", _hoisted_8, [
            (_unref(canWrite))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
                  onClick: ($event: any) => (handleAdd(args))
                }, [
                  _createVNode(_component_copy_outlined),
                  _createTextVNode(" 添加一行 ")
                ], 10, _hoisted_9))
              : _createCommentVNode("", true),
            (_unref(canWrite))
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  class: _normalizeClass(["popup-item", args.column.key === 'operation' && 'disabled']),
                  onClick: ($event: any) => (onDelete(args.record.id, args.record.key, args))
                }, [
                  _createVNode(_component_copy_outlined),
                  _createTextVNode(" 删除 ")
                ], 10, _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["data-source", "pagination", "row-selection"])
    ]),
    (showViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewSrcList.value,
          onClose: closeViewer,
          infinite: false
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})